module.exports = __webpack_public_path__ + "img/qrcode.7c920ce0.jpg";